import rxios from '../common/rxios'
import { merge, of } from 'rxjs'
import { map } from 'rxjs/operators'
import { map as _map, join, filter } from 'lodash-es'

export const marketPlaceHierarhcyService = {
  getMarketPlaceGnbHierarchy$() {
    return merge(
      of(require('./json/getMarketPlaceGnbHierarchy$.json$').hierarchy),
      rxios.get(`${domain.homepage}/homepage/v1/marketplace/gnb/hierarchies`).pipe(map(response => response.data.hierarchy))
    )
  },
  getMarketPlaceMainHierarchyList$() {
    return merge(
      of(require('./json/getMarketPlaceMainHierarchyList$.json$').hierarchyList),
      rxios.get(`${domain.homepage}/homepage/v1/marketplace/main/hierarchies`).pipe(map(response => response.data.hierarchyList))
    )
  },
  getMarketPlaceLnbHierarchyList$() {
    return merge(
      of(require('./json/getMarketPlaceLnbHierarchyList$.json$').hierarchyList),
      rxios.get(`${domain.homepage}/homepage/v1/marketplace/lnb/hierarchies`).pipe(map(response => response.data.hierarchyList))
    )
  },
  getMarketPlaceOverviewHierarchyList$() {
    return rxios.get(`${domain.homepage}/homepage/v1/marketplace/overview/hierarchies`).pipe(map(response => response.data.hierarchy))
  },
  getMarketPlaceByProductId$() {
    return rxios.get(`${domain.homepage}/homepage/v1/marketplace/overview/hierarchies`).pipe(map(response => response.data.hierarchy))
  },
  getMarketPlaceMenuClass(service) {
    return join(_map(service.badges, badge => `is_${badge.trim()}`), ' ')
  },
  getMarketPlaceOverviewBadgeClass(service) {
    const badges = _map(service.badges, badge => badge.trim())
    const filterd = filter(badges, badge => badge == 'beta' || badge == 'alpha')
    const mapped = _map(filterd, badge => `is_${badge}`)
    return join(mapped, ' ')
  },
  getServiceOverviewBadgeClass(service) {
    const badges = _map(service.badges, badge => badge.trim())
    const filterd = filter(badges, badge => badge == 'beta' || badge == 'alpha')
    const mapped = _map(filterd, badge => `is_${badge}`)
    return join(mapped, ' ')
  }
}
